import { ClipLoader } from 'react-spinners'

import { Color } from '../../theme/color'
import type { ColorValues } from '../../theme/color'

interface SpinnerProps {
  size?: number
  color?: ColorValues
}

export function Spinner({ size, color }: SpinnerProps) {
  return <ClipLoader color={color ?? Color.white} size={size ?? 60} />
}
